const baseTheme = {
    fonts: ['sans-serif', 'Arimo'],
    fontSizes: {
      small: '1em',
      medium: '2em',
      large: '3em',
    },
    colors: {
      primary: '#fff',
      white: '#fff', 
    },
    baseColors: {
      primary: '#BD2C43',
      secondary: '#4B4B4B',
      gray: '#DFE1E7',
      veryLightGray: '#F4F4F4',
      lightGray: '#e7e7e7',
      mediumGray: '#d8d8d8',
      mediumDarkShadeGray: '#78848A',
      darkShadeGray: '#323232',
      darkGray: '#4B4B4B',
      beigeGray: '#7d7570',
      dirtGray: '#B9B9B9',
      highGray: '#7A819B',
      white: '#FEFEFE',
      pureWhite: '#FFFFFF',
      black: '#000B31',
      mediumBlack: '#161616',
      pureBlack: '#000E40',
      lightBlack: '#002A3E',
      dirtWhite: '#fafaf9',
      brownishGrey: '#777474',
      greyishBrown: '#565656',
      error: '#B20221',
      textLight: '#7e7470',
      blueDark: '#0075C9',
      orange: '#F68B1F'
    }
  }
  
  export default baseTheme
  